import { createStore } from "state-pool";

export const store = createStore({
    account: "",
    email: "",
    balance: "0",
    userInfo: {},
    coupons: []
})